export default function useKnipsPostFormatter(rawItems) {
  let formattedPosts = [];

  if (!rawItems?.length) return [];

  formattedPosts = rawItems.map(item => {
    const [titleLine = '', ...restLines] = item.text.split('\n') || [];
    const excerpt = restLines.join('\n');

    let imageUrl = '';
    const imageBlock = item.blocks.find(block => block.type === 'image');
    if (imageBlock) {
      imageUrl = imageBlock.imageUrl;
    }

    return {
      id: item.id,
      title: titleLine,
      text: excerpt,
      url: item.url,
      publishDate: item.publishDate,
      imageSrc: imageUrl
    };
  });

  return formattedPosts;
}
